/**
 * @generated SignedSource<<c3ff23ecac90207eaa41815b8f8d3ba7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoListItemDeadline_todo$data = {
  readonly expireAt: string | null;
  readonly expireAtFormatted: string | null;
  readonly " $fragmentType": "WidgetTodoListItemDeadline_todo";
};
export type WidgetTodoListItemDeadline_todo$key = {
  readonly " $data"?: WidgetTodoListItemDeadline_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoListItemDeadline_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoListItemDeadline_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAtFormatted",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "b14349c27124c9ffde3e203bc176623a";

export default node;
